import {
  Editor,
  Transforms,
  Range,
  Point,
  Node,
  Element as SlateElement,
} from 'slate';

import types from '../../elements/types';

/**
 * Indentation rules:
 * 1. It cannot be empty. If it is empty, it needs to be deleted.
 * 
 * 
 * 
 * **/

function withIndentation(editor) {

  const { normalizeNode, deleteBackward } = editor;

  editor.normalizeNode = entry => {

    const [node, path] = entry;

    if (node.type === types.INDENTATION) {

      if (node.children.length === 0) {
        Transforms.removeNodes(editor, { at: path });
        return;
      }

    }

    // If no schema violations, continue with the next normalization rule
    normalizeNode(entry);

  };

  function _deleteBackward(...args) {

    const { selection } = editor;

    if (selection && Range.isCollapsed(selection)) {
      const [match] = Editor.nodes(editor, {
        match(node) {
          return !Editor.isEditor(node) &&
            SlateElement.isElement(node) &&
            node.type === types.INDENTATION;
        },
        reverse: true,
        mode: 'lowest'
      });

      if (match) {
        const [node, path] = match;
        const start = Editor.start(editor, path);

        if (Point.equals(selection.anchor, start) && node.children.length === 1 && Node.string(node) === '') {
          Transforms.liftNodes(editor, { at: [...path, 0] });
          return;
        }
      }
    }

    deleteBackward(...args);

  }

  editor.deleteBackward = _deleteBackward;

  return editor;

};

export default withIndentation;